import { useState } from "react";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";

type Props = {
  open: boolean;
  apiKey: string | null;
  onClose: () => void;
};

export function RevealKeyModal({ open, apiKey, onClose }: Props) {
  const [acknowledged, setAcknowledged] = useState(false);

  const copy = async () => {
    if (!apiKey) return;
    await navigator.clipboard.writeText(apiKey);
    toast.success("In die Zwischenablage kopiert");
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o && acknowledged) {
          onClose();
          setAcknowledged(false);
        }
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>API-Key — jetzt kopieren</DialogTitle>
          <DialogDescription>
            Dieser Key wird nur EIN Mal angezeigt. Wenn du dieses Fenster
            schließt ohne ihn zu kopieren, ist er nicht mehr abrufbar.
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-md border bg-muted p-3 font-mono text-xs break-all">
          {apiKey ?? ""}
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={copy}>
            <Copy className="mr-2 h-3.5 w-3.5" />
            Kopieren
          </Button>
        </div>
        <label className="flex items-center gap-2 text-sm">
          <input
            type="checkbox"
            checked={acknowledged}
            onChange={(e) => setAcknowledged(e.target.checked)}
          />
          Ich habe den Key sicher gespeichert.
        </label>
        <DialogFooter>
          <Button
            disabled={!acknowledged}
            onClick={() => {
              onClose();
              setAcknowledged(false);
            }}
          >
            Schließen
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
